import { Theme, css } from '@emotion/react';

export const formControlLabelRoot =
  () =>
  ({ spacing, colors }: Theme) => css`
    align-items: flex-start;

    &.MuiFormControlLabel-root {
      margin-left: -${spacing(0.75)}px;
    }

    &.Mui-disabled .MuiTypography-root {
      color: ${colors.fgDisabled};
    }
  `;

export const formControlLabelTextWrapper =
  () =>
  ({ spacing }: Theme) => css`
    display: grid;
    padding-top: ${spacing(0.75)}px;
    padding-left: ${spacing(0.25)}px;
    gap: ${spacing(0.5)}px;
  `;
